import { render, staticRenderFns } from "./MemberAccept.vue?vue&type=template&id=20af9e10&scoped=true&"
import script from "./MemberAccept.vue?vue&type=script&lang=js&"
export * from "./MemberAccept.vue?vue&type=script&lang=js&"
import style0 from "./MemberAccept.vue?vue&type=style&index=0&id=20af9e10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af9e10",
  null
  
)

export default component.exports